import { Driver, Vehicle } from "../my-type";
import { authUserData } from ".";
import {
  DriverService as GeneratedDriverService,
  TeamService as GeneratedTeamService,
  callApi,
  configureApiClient,
  fetchWithApiClient,
} from "../api/client";

const configureDriverApiClient = () => {
  configureApiClient({
    tokenProvider: () => authUserData()?.jwtToken ?? null,
  });
};

type UploadDriverPhotoResponse = {
  message: string;
  fileName: string;
};

export const getDriver = async (userUId: number) => {
  try {
    configureDriverApiClient();
    const data = await callApi(
      () => GeneratedDriverService.getApiDriver(userUId),
      "取得司機資料失敗"
    );
    return data as unknown as Driver;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const createDriver = async (driver: Driver) => {
  try {
    configureDriverApiClient();
    const data = await callApi(
      () => GeneratedDriverService.postApiDriver(driver as unknown as import("../generated/api").Driver),
      "建立司機資料失敗"
    );
    return data as unknown as Driver;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const updateDriver = async (driver: Driver) => {
  try {
    configureDriverApiClient();
    const data = await callApi(
      () =>
        GeneratedDriverService.putApiDriver(
          driver.id,
          driver as unknown as import("../generated/api").Driver
        ),
      "更新司機資料失敗"
    );
    return data as Driver;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getDriversByTeamCode = async (teamCode: string) => {
  try {
    configureDriverApiClient();
    const data = await callApi(
      () => GeneratedDriverService.getApiDriverTeamDrivers(teamCode),
      "取得車隊司機資料失敗"
    );
    return data as Driver[];
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const searchDrivers = async (teamCode: string, keyword: string) => {
  try {
    configureDriverApiClient();
    const data = await callApi(
      () => GeneratedDriverService.getApiDriverSearchDrivers(teamCode, keyword),
      "搜尋司機失敗"
    );
    return data as Driver[];
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const approveApply = async (userUId: number) => {
  try {
    configureDriverApiClient();
    await callApi(
      () => GeneratedDriverService.postApiDriverApproveApply(userUId),
      "審核司機申請失敗"
    );
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export const disableDriver = async (userUId: number) => {
  try {
    configureDriverApiClient();
    await callApi(
      () => GeneratedDriverService.postApiDriverDisableDriver(userUId),
      "停用司機失敗"
    );
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export const approveLeadApply = async (userUId: number) => {
  try {
    configureDriverApiClient();
    await callApi(
      () => GeneratedDriverService.postApiDriverApproveLeadApply(userUId),
      "審核代理隊長申請失敗"
    );
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export const uploadDriverPhoto = async (
  photo: File,
  fileType: 'CarLicensePhoto' | 'MotorLicensePhoto' | 'InsurancePhoto',
  userUID: number
): Promise<UploadDriverPhotoResponse> => {
  if (!photo || !(photo instanceof File)) {
    throw new Error("Invalid photo file provided.");
  }

  try {
    configureDriverApiClient();
    const data = await callApi(
      () =>
        GeneratedDriverService.postApiDriverUploadDriverPhoto(fileType, userUID, {
          photo,
        }),
      "上傳司機照片失敗"
    );
    return data as UploadDriverPhotoResponse;
  } catch (error) {
    console.error("Error uploading driver photo:", error);
    throw error;
  }
};

export const getDriverPhoto = async (fileName: string): Promise<string | null> => {
  try {
    configureDriverApiClient();
    const response = await fetchWithApiClient(
      `/api/Driver/GetPhoto?fileName=${encodeURIComponent(fileName)}`,
      {
        method: "GET",
      }
    );

    if (!response.ok) {
      console.error("Error fetching driver photo:", response.status);
      return null;
    }

    const blob = await response.blob();
    return URL.createObjectURL(blob);
  } catch (error) {
    console.error("Error fetching driver photo:", error);
    return null;
  }
};

export const updateTeamVehicle = async (teamCode: string, vehicleData: Vehicle[]) => {
  try {
    configureDriverApiClient();
    await callApi(
      () =>
        GeneratedTeamService.putApiTeamChangeVehicleData(
          teamCode,
          JSON.stringify(vehicleData)
        ),
      "更新車隊車型設定失敗"
    );
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};
